import { render } from "./ProductFormTabInventory.vue?vue&type=template&id=1185eb67"
import script from "./ProductFormTabInventory.vue?vue&type=script&lang=js"
export * from "./ProductFormTabInventory.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__